import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../graphql/common.datatypes';
import {WcvLog} from '../../graphql/logs.datatypes';

interface LogsData {
    groupLogs: void,
    logs: {
        data: WcvLog[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const gqlLog = `
    id
    level
    type
    type_id
    code
    description
    resolved
    payload
    created_at

    user {
        id
        first_name
        last_name
        email
    }
    `;

// targetUser {
//     id
//     first_name
//     last_name
//     email
// }

// targetRole {
//     id
//     name
//     ident
// }

// targetPermission {
//     id
//     name
//     ident
// }

// targetGroup {
//   id
//   name
// }

// targetGroupMember {
//   id
//   email
// }

export const GET_LOGS_QUERY = gql`
    query getLogs($count: Int!, $page: Int!, $where: WhereConditions, $orderBy: [OrderByClause!]){
        logs(first: $count, page: $page, where: $where, orderBy: $orderBy){
            data {
                ${gqlLog}
            }
            ${gqlPaginatorInfo}
        }
    }
`;

export const getLogs = (count: number, page: number, where?: any, orderBy?: any) => useQuery<LogsData>(
    GET_LOGS_QUERY,
    {
        variables: {
        count,
        page,
        where,
        orderBy,
      },
    }
);

export default getLogs;
